export const QUERY_REQUIREMENT_DEFINITIONS_LIST =
  "QUERY_REQUIREMENT_DEFINITIONS_LIST";
export const QUERY_REQUIREMENT_DEFINITION = "QUERY_REQUIREMENT_DEFINITION";
export const QUERY_REQUIREMENT_DEFINITIONS_LIST_All =
  "QUERY_REQUIREMENT_DEFINITIONS_LIST_All";
